// TODO [refactor]: move this enum to the entity store
export enum EntityTypesEnum {
  appointment = 'appointment',
  invoice = 'invoice',
  estimate = 'estimate',
  purchase_order = 'purchase_order',
  credit_memo = 'credit_memo',
  client = 'client',
  expense = 'expense',
  product = 'product',
  tracked_time = 'tracked_time',
}
